import type { Path, PathValue, UseFormReturn } from 'react-hook-form';
import type { SubtypeFormName } from './useSubtypeFormNames';

type useWatchSubtypedResult<
    T extends object,
    N extends ReadonlyArray<unknown>,
    Acc extends ReadonlyArray<unknown> = [],
> =
    N['length'] extends Acc['length'] ? Acc
    :   useWatchSubtypedResult<
            T,
            N,
            [...Acc, PathValue<T, N[Acc['length']] & Path<T>> | undefined]
        >;

export const useWatchSubtypeProperties = <
    T extends object,
    const N extends Array<SubtypeFormName<T> | undefined>,
>({
    form,
    names,
}: {
    form: UseFormReturn<T>;
    names: N;
}) => {
    return form.watch(names as Array<Path<T>>) as useWatchSubtypedResult<T, N>;
};
